import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { setHours, setMinutes, setSeconds } from 'date-fns';
import { _getTimeDetails, prependZeros } from '../utils';
import { UXPContext } from "@core/context/Context";
import ButtonComponent from "@widget/buttons/ButtonComponent";
import Input from "../../Input";
const Clock = (props) => {
    const context = React.useContext(UXPContext);
    // props
    let { time, onChange, disableInput = false } = props;
    // state
    let [timeObj, setTimeObj] = React.useState({ hours: null, mins: null, secs: null, evening: false, timeString: "" });
    let [dateTime, setDateTime] = React.useState(new Date());
    let [hourInput, setHourInput] = React.useState('');
    let [minuteInput, setMinuteInput] = React.useState('');
    React.useEffect(() => {
        let timeDetails = _getTimeDetails(time, true);
        setTimeObj(timeDetails);
        setDateTime(timeDetails.date);
        setHourInput(prependZeros(timeDetails.hours));
        setMinuteInput(prependZeros(timeDetails.mins));
    }, [time]);
    // onchange events
    const onChangeHandler = (h, m, s) => {
        let _date = dateTime;
        if (!h)
            h = timeObj.hours;
        if (typeof m == undefined)
            m = timeObj.mins;
        let isEvening = timeObj.evening;
        if (s)
            isEvening = s == "pm";
        if (isEvening && h < 12)
            h += 12;
        if (!isEvening && h == 12)
            h += 12;
        if (h)
            _date = setHours(_date, h);
        if (m || m == 0)
            _date = setMinutes(_date, m);
        _date = setSeconds(_date, 0);
        onChange(_date);
    };
    const incrementHour = () => {
        let newHour = timeObj.hours + 1;
        if (newHour > 12)
            newHour = 1;
        onChangeHandler(newHour);
    };
    const decrementHour = () => {
        let newHour = timeObj.hours - 1;
        if (newHour < 1)
            newHour = 12;
        onChangeHandler(newHour);
    };
    const incrementMinute = () => {
        let newMin = timeObj.mins + 1;
        if (newMin > 59)
            newMin = 0;
        onChangeHandler(null, newMin);
    };
    const decrementMinute = () => {
        let newMin = timeObj.mins - 1;
        if (newMin < 0)
            newMin = 59;
        onChangeHandler(null, newMin);
    };
    const handleHourChange = (val) => {
        // Allow free-form editing, validation happens on blur
        setHourInput(val);
    };
    const handleHourBlur = () => {
        const num = parseInt(hourInput);
        if (isNaN(num) || num < 1 || num > 12) {
            // Reset to current valid value
            setHourInput(prependZeros(timeObj.hours));
        }
        else {
            // Update time and format
            onChangeHandler(num);
            setHourInput(prependZeros(num));
        }
    };
    const handleMinuteChange = (val) => {
        // Allow free-form editing, validation happens on blur
        setMinuteInput(val);
    };
    const handleMinuteBlur = () => {
        const num = parseInt(minuteInput);
        if (isNaN(num) || num < 0 || num > 59) {
            // Reset to current valid value
            setMinuteInput(prependZeros(timeObj.mins));
        }
        else {
            // Update time and format
            onChangeHandler(null, num);
            setMinuteInput(prependZeros(num));
        }
    };
    return (_jsx("div", { className: "uxpcore_clock", children: _jsxs("div", { className: "uxpcore_clock__time-display", children: [_jsxs("div", { className: "uxpcore_clock__field", children: [_jsx(ButtonComponent, { leftIcon: ['far', 'chevron-up'], iconOnly: true, size: "small", variant: "secondary", onClick: incrementHour, disabled: disableInput, className: "uxpcore_clock__input-button" }), _jsx("div", { className: "uxpcore_clock__input-wrapper", children: _jsx(Input, { type: "text", value: hourInput, onChange: handleHourChange, onBlur: handleHourBlur, inputAttr: { maxLength: '2' }, disabled: disableInput, readOnly: disableInput, hideClear: true }) }), _jsx(ButtonComponent, { leftIcon: ['far', 'chevron-down'], iconOnly: true, size: "small", variant: "secondary", onClick: decrementHour, disabled: disableInput, className: "uxpcore_clock__input-button" })] }), _jsx("span", { className: "uxpcore_clock__separator", children: ":" }), _jsxs("div", { className: "uxpcore_clock__field", children: [_jsx(ButtonComponent, { leftIcon: ['far', 'chevron-up'], iconOnly: true, size: "small", variant: "secondary", onClick: incrementMinute, disabled: disableInput, className: "uxpcore_clock__input-button" }), _jsx("div", { className: "uxpcore_clock__input-wrapper", children: _jsx(Input, { type: "text", value: minuteInput, onChange: handleMinuteChange, onBlur: handleMinuteBlur, inputAttr: { maxLength: '2' }, disabled: disableInput, readOnly: disableInput, hideClear: true }) }), _jsx(ButtonComponent, { leftIcon: ['far', 'chevron-down'], iconOnly: true, size: "small", variant: "secondary", onClick: decrementMinute, disabled: disableInput, className: "uxpcore_clock__input-button" })] }), _jsxs("div", { className: "uxpcore_clock__ampm-group", children: [_jsx(ButtonComponent, { title: context.$L('uxp-core.text.am'), size: "small", variant: !timeObj.evening ? "primary" : "secondary", onClick: () => onChangeHandler(null, null, "am"), disabled: disableInput }), _jsx(ButtonComponent, { title: context.$L('uxp-core.text.pm'), size: "small", variant: timeObj.evening ? "primary" : "secondary", onClick: () => onChangeHandler(null, null, "pm"), disabled: disableInput })] })] }) }));
};
export default Clock;
